export default function NavigatableIntegrationHeaderLabel({ text }) {
  return (
    <div className="NavigatableIntegrationWidgetCard-HeaderLabel">{text}</div>
  )
}
